module.exports = __webpack_public_path__ + "static/media/iphone-lastpage.3ba8fd78.png";